import React from 'react'

import { Form, Col } from '_zari/core'

const NumeroSerieFormGroup = ({ value, onChange }) => {
  return (
    <Form.Group>
      <Form.Label text='CORRELATIVO' htmlFor='input-numeroSerie' md={4} />
      <Col md={8}>
        <Form.InputText
          id='input-numeroSerie'
          placeholder='Ingrear correlativo ...'
          value={value}
          onChange={onChange}
        />
      </Col>
    </Form.Group>
  )
}

export default NumeroSerieFormGroup
